const overrides = {
  wrapper: {
    marginBottom: 0,
    overflow: 'visible',
    border: 'none',
    borderRadius: 0,
    background: '#fff',
  },
  header: {
    padding: '20px 24px 16px',
    borderBottom: '1px solid #e6eeeb',
    background: '#fff',
  },
  headerTitle: { color: '#1e2248', fontSize: 16, lineHeight: 1.35 },
  headerSub: { color: '#66708a', fontSize: 13, lineHeight: 1.5 },
  headerMeta: { color: '#66708a', fontSize: 11 },
  zone: { background: '#fff' },
  searchContainer: {
    padding: '16px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fbfefd',
  },
  searchRow: {
    padding: '16px 20px 10px',
    borderBottom: 0,
    background: '#fbfefd',
  },
  searchInput: {
    minHeight: 40,
    padding: '8px 12px',
    border: '1px solid #d5e1dd',
    borderRadius: 8,
    background: '#fff',
    color: '#1e2248',
    fontSize: 13,
  },
  searchHint: {
    padding: '0 20px 12px',
    borderBottom: '1px solid #edf2f0',
    background: '#fbfefd',
    color: '#66708a',
    fontSize: 11,
  },
  addRow: {
    gap: 8,
    padding: '16px 20px',
    borderTop: '1px solid #edf2f0',
    background: '#fbfefd',
  },
  addInput: {
    minHeight: 40,
    padding: '8px 12px',
    border: '1px solid #d5e1dd',
    borderRadius: 8,
    color: '#1e2248',
    fontSize: 13,
  },
  addBtn: {
    minHeight: 40,
    padding: '0 16px',
    border: '1px solid var(--kea-color-primary-border)',
    borderRadius: 999,
    background: '#fff',
    color: 'var(--kea-color-primary)',
    fontSize: 12,
    fontWeight: 600,
  },
  emptyState: {
    margin: '12px 16px',
    padding: '20px 16px',
    border: '1px dashed #c8d9d2',
    borderRadius: 6,
    background: '#fbfefd',
    color: '#66708a',
    fontSize: 13,
    lineHeight: 1.5,
  },
  divider: {
    gap: 12,
    padding: '10px 20px',
    borderTop: '1px solid #e6eeeb',
    borderBottom: '1px solid #e6eeeb',
    background: '#f9fffd',
    color: '#66708a',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  dividerLine: { background: '#ddeae5' },
  pinnedRow: {
    minHeight: 56,
    gap: 10,
    padding: '10px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fff',
  },
  generatedRow: {
    minHeight: 56,
    gap: 12,
    padding: '10px 20px',
    borderBottom: '1px solid #edf2f0',
    background: '#fff',
  },
  dragHandle: {
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    color: '#8790a5',
  },
  pinnedBadge: {
    padding: '3px 7px',
    borderRadius: 999,
    background: 'var(--kea-color-primary-soft)',
    color: 'var(--kea-color-primary)',
  },
  removeBtn: {
    width: 32,
    height: 32,
    padding: 0,
    borderRadius: 6,
    color: '#8790a5',
  },
  pinBtn: {
    minHeight: 32,
    padding: '0 12px',
    border: '1px solid var(--kea-color-primary-border)',
    borderRadius: 999,
    background: '#fff',
    color: 'var(--kea-color-primary)',
    fontSize: 12,
    fontWeight: 600,
  },
  pinBtnDisabled: {
    minHeight: 32,
    padding: '0 12px',
    border: '1px solid #e1e9e6',
    borderRadius: 999,
    background: '#f3f6f5',
    color: '#8790a5',
    fontSize: 12,
  },
  generatedTerm: { color: '#1e2248', fontSize: 13 },
  generatedWord: { color: '#1e2248', fontSize: 13 },
  generatedCount: { color: '#8790a5', fontSize: 11 },
  generatedPrice: { color: '#1e2248', fontSize: 12 },
  productName: { color: '#1e2248', fontSize: 13, fontWeight: 600 },
  catName: { color: '#1e2248', fontSize: 13, fontWeight: 600 },
  productMeta: { color: '#66708a', fontSize: 11 },
  catPath: { color: '#66708a', fontSize: 11 },
  productId: { color: '#8790a5' },
  catId: { color: '#8790a5' },
  thumb: { borderRadius: 6, background: '#f1f3f6' },
  thumbEmpty: { borderRadius: 6, background: '#f1f3f6', color: '#8790a5' },
  dropdown: {
    border: '1px solid #ddeae5',
    borderRadius: 8,
    boxShadow: '0 12px 28px rgba(30, 34, 72, 0.14)',
  },
  dropdownItem: {
    padding: '10px 12px',
    borderBottom: '1px solid #edf2f0',
  },
  dropdownName: { color: '#1e2248', fontWeight: 600 },
  dropdownPath: { color: '#66708a' },
  dropdownCount: { color: '#8790a5' },
  dropdownEmpty: { color: '#66708a' },
  editInput: {
    minHeight: 36,
    padding: '6px 10px',
    border: '1px solid var(--kea-color-primary)',
    borderRadius: 8,
    color: '#1e2248',
  },
  editConfirmBtn: { color: 'var(--kea-color-primary)' },
  editCancelBtn: { color: '#8790a5' },
  editHint: { color: '#a9455e' },
  duplicateHint: { color: '#9a6a1f' },
  unresolvedRow: { background: '#fff9ec' },
  unresolvedBadge: {
    border: '1px solid #efdfbd',
    borderRadius: 999,
    background: '#fff9ec',
    color: '#9a6a1f',
  },
};

export default function applyEditorTheme(styles) {
  return Object.entries(styles).reduce((themed, [key, value]) => ({
    ...themed,
    [key]: overrides[key] ? { ...value, ...overrides[key] } : value,
  }), {});
}
